import { FC } from 'react';
import { Link } from 'react-router-dom';

import { LinkHelper } from '@/Services';

import { DeviceCard } from '../DeviceCard';
import { StationCardProps } from './StationCard.types';
import S from './styles.module.scss';

export const StationCard: FC<StationCardProps> = ({ station }) => {
    return (
        <Link to={LinkHelper.iRomaScentsNotificationsStationId(station.id)} className={S.card}>
            <h3 className={S.card_title}>{station.name}</h3>
            <div className={S.card_devices}>
                {station.devices.map((device) => (
                    <DeviceCard stationId={station.id} device={device} key={`device_${device.id}`} />
                ))}
            </div>
        </Link>
    );
};
